import React from "react";
import {ReactComponent as LogoSvg} from "../../static/logo.svg";
import styles from "./Logo.module.scss"

export const Logo = () => <div className={styles.wrapper}><LogoSvg /></div>
